import React, { useState } from "react";
import '../../css/components/controls/HrnbImage.css'

export default function HrnbImage({
                                      src,
                                      alt = "",
                                      size = 80,
                                      rounded = false,
                                      className = "",
                                      fallback = null,
                                      style = {},
                                      onClick,
                                      skeleton = false,
                                      ...props
                                  }) {
    const [loaded, setLoaded] = useState(false);
    const [error, setError] = useState(false);

    return (
        <div
            className={
                `hrnb-image-wrap${rounded ? " hrnb-image--rounded" : ""} ${className}`
            }
            style={{
                width: size,
                height: size,
                ...style
            }}
            onClick={onClick}
        >
            {(!loaded && skeleton) && (
                <div className="hrnb-image__skeleton" />
            )}
            {!error && src && (
                <img
                    className="hrnb-image"
                    src={src}
                    alt={alt}
                    style={{
                        display: loaded ? "block" : "none",
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: rounded ? "50%" : "10px"
                    }}
                    onLoad={() => setLoaded(true)}
                    onError={() => setError(true)}
                    {...props}
                />
            )}
            {(error || !src) && fallback}
        </div>
    );
}
